export default {
  pageTitle: 'Radiant Tube Fabrication',
  metaDescription: 'TEF fabricates U-type radiant tubes and heater tubes in high-nickel alloys for furnace and heating applications in the process industry.',
  sidebar: {
    title: 'Fabrication list',
    vessel: 'Fabrication Vessel',
    heatExchanger: 'Fabrication Heat Exchanger',
    piping: 'Fabrication Piping',
    tower: 'Fabrication Tower',
    muffle: 'Fabrication Muffle',
    radiantTube: 'Fabrication Radiant Tube',
    otherEquipment: 'Fabrication Other Equipment',
  },
  fabricationOf: 'Fabrication of',
  productName: 'Radiant Tube',
  description: 'Below is a catalog of our experience in Radiant Tube fabrication across various materials, types, and specifications.',
};
